export default __webpack_public_path__ + "static/GPE_blue-c3d7f178119c4af5b599acd02cbec7da.png";